import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import StaffSelector from "./staff-selector.vue";
import { StaffSelectorControl } from "../controls/staff-selector-control";
import { Tag, Icon, Avatar } from "@h3/antd-vue";
let FormStaffSelector = class FormStaffSelector extends StaffSelectorControl {
    constructor() {
        super(...arguments);
        this.showToggle = false;
        this.collapsed = true;
    }
    toggle() {
        this.collapsed = !this.collapsed;
    }
    scroll() {
        const el = this.$el.querySelector('.form-staff');
        if (el) {
            this.showToggle = el.scrollHeight > el.offsetHeight + 3;
            if (el.offsetHeight === 0) {
                clearTimeout(this.taskRef);
                this.taskRef = setTimeout(() => {
                    this.scroll();
                }, 1000);
            }
        }
    }
    onValueChange(value) {
        const val = value && value.length > 0 ? value : null;
        this.setValue(val);
    }
    mounted() {
        // 选人控件需要从根节点开始显示
        this.staffSelectorOpts.isDisplayRoot = true;
        if (this.readonly) {
            this.$nextTick(() => {
                this.scroll();
            });
        }
    }
    // 是否为外部用户
    get isExternal() {
        if (window.isExternal) {
            return true;
        }
        return false;
    }
};
FormStaffSelector = tslib_1.__decorate([
    Component({
        name: "form-staff-selector",
        components: {
            ATag: Tag,
            AIcon: Icon,
            AAvatar: Avatar,
            StaffSelector
        }
    })
], FormStaffSelector);
export default FormStaffSelector;
